"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PremiumMoveSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10,14 L10,15 L4,15 L4,14 L10,14 Z M14.7843055,10.0885912 L14.8535534,10.1464466 L17.2071068,12.5 L14.8535534,14.8535534 C14.6582912,15.0488155 14.3417088,15.0488155 14.1464466,14.8535534 C13.9728803,14.679987 13.9535951,14.4105626 14.0885912,14.2156945 L14.1464466,14.1464466 L15.292,13 L12,13 L12,12 L15.292,12 L14.1464466,10.8535534 C13.9728803,10.679987 13.9535951,10.4105626 14.0885912,10.2156945 L14.1464466,10.1464466 C14.320013,9.97288026 14.5894374,9.95359511 14.7843055,10.0885912 Z M4.5,4 C4.77614237,4 5,4.22385763 5,4.5 L5,5 C5,5.82842712 5.67157288,6.5 6.5,6.5 C7.32842712,6.5 8,5.82842712 8,5 L8,4.5 C8,4.22385763 8.22385763,4 8.5,4 L9.5,4 C9.77614237,4 10,4.22385763 10,4.5 L10,5 C10,5.82842712 10.6715729,6.5 11.5,6.5 C12.3284271,6.5 13,5.82842712 13,5 L13,4.5 C13,4.22385763 13.2238576,4 13.5,4 L14.5,4 C14.7761424,4 15,4.22385763 15,4.5 L14.5655311,7.99944047 L13.558,8 L13.8155978,5.94408903 C13.4430984,6.85679414 12.5466636,7.5 11.5,7.5 C10.1192881,7.5 9,6.38071187 9,5 C9,6.38071187 7.88071187,7.5 6.5,7.5 C5.45333643,7.5 4.55690164,6.85679414 4.18440224,5.94408903 L4.94139111,12 L10,12 L10,12.999 L4.05860889,13 L3,4.5 C3,4.22385763 3.22385763,4 3.5,4 L4.5,4 Z" })));
};
PremiumMoveSmall.displayName = 'PremiumMoveSmall';
exports.default = PremiumMoveSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PremiumMoveSmall.js.map